import { render, staticRenderFns } from "./ZTWSEventCreate.vue?vue&type=template&id=584ac436"
import script from "./ZTWSEventCreate.vue?vue&type=script&lang=js"
export * from "./ZTWSEventCreate.vue?vue&type=script&lang=js"
import style0 from "./ZTWSEventCreate.vue?vue&type=style&index=0&id=584ac436&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports